import styled from 'styled-components'

import * as HeroBg from '../../../assets/fond_SL_Nextories4.jpg'

export const Wrapper = styled.div`
  padding: 48px 0;
  background-image: url(${HeroBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media screen and (max-width: 460px) {
    background-image: none;
    background-color: #f3f3f3;
  }
`

export const Content = styled.div`
  max-width: 916px;
  margin: 0 auto;

  @media screen and (max-width: 920px) {
    padding: 0 12px;
  }
`

export const Title = styled.div`
  @keyframes showText {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  color: #253163;
  font-size: 32px;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 23px;
  max-width: 600px;
  animation-name: showText;
  animation-duration: 1s;
`
